import InternalTransfersPage from './InternalTransfersPage';

export default InternalTransfersPage;
